/* unplugin-vue-components disabled */import { render } from "./ReviewAnswerView.vue?vue&type=template&id=a868c416&scoped=true"
import script from "./ReviewAnswerView.vue?vue&type=script&lang=js"
export * from "./ReviewAnswerView.vue?vue&type=script&lang=js"

import "./ReviewAnswerView.vue?vue&type=style&index=0&id=a868c416&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a868c416"]])

export default __exports__